<template>
	<bsh-modal 
		titulo="Finalizar Quantidade"
		:name="name">
		<template v-slot:default>
	        <div class="form-row">
			    <div class="form-group col-md-12">
			        <label>Quantidade</label>
			        <input 
			        	type="number" 
			        	class="form-control" 
			        	v-model="dados.quantidade_finalizada" 
			        	:id="name+'quantidade_finalizada'" 
			        	@input="clearValidation('quantidade_finalizada')">
			        <div class="invalid-feedback" :id="name+'quantidade_finalizada-invalid-feedback'"></div>
			    </div>
			</div>
	    </template>
	    <template v-slot:footer>
        	<button 
        		type="button" 
        		class="btn btn-primary" 
        		@click="update">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	export default {
		props: ['itemId'],
		data(){
			return {
				name: "update_quantidade_finalizada",
				dados: {
					quantidade_finalizada: 1
				},
				elementos: []
			}
		}, 
		created(){
			this.elementos = Object.keys(this.dados);
		},
		methods: {
			update(){
				var config = {
					position: 'bottom-right',
				};
				const id = this.itemId || this.$route.params.id;
	            axios.put(this.$url+'/api/adm/itens/finalizar-unidade/'+id, (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type, config)
	              	this.$emit('reload')
	            })
	            .catch(error => {
	            	this.$bshValidation.valide(this.elementos, error.response.data.errors, this.name)
	            });
        	},
        	clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			}
		},
	}
</script>